import React from 'react'
import { PremButton, HorizontalScroller, Button, Column } from '../Blocks'
import styled from 'styled-components'
import { state } from '../../context/store'

const OptionPanel = ({
  id,
  children,
  maxWidth = 'var(--max-panel-width)',

}) => {

  return (
    <Wrap id={`option-panel-${id}`} $maxWidth={maxWidth}>

      {children}
    </Wrap>
  )

}

export default OptionPanel

const Wrap = styled.div`

  display: flex;
  flex-direction: column;
  row-gap: 12px;
  justify-content: ${(props) => props.$justify};
  width: ${(props) => props.$width};
  /* background: red; */


  @media (width > 800px) {
    justify-content: center !important;
    align-items: center !important;
    max-width: ${(props) => `min(${props.$maxWidth}, 100%)`};
  }
`
